// Global pagination constants with TypeScript types

export const ITEMS_PER_PAGE_OPTIONS: readonly number[] = [
  5, 10, 20, 50,
] as const;

export const DEFAULT_PAGE_SIZE: number = 10;
export const DEFAULT_PAGE: number = 1;

// Type for items per page options
export type ItemsPerPageOption = (typeof ITEMS_PER_PAGE_OPTIONS)[number];
